// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { observer } from 'mobx-react';
import { withStyles } from "tss-react/mui";
import { Dialog } from '@mui/material';
import container from '@core/di';
import OrdersStore from '@shared/stores/orders';
import { AssetDTO } from '@shared/models/asset';
import { CustomerDTO } from '@shared/models/customers';
import { ManageMode, FormProps } from '@shared/components/Form';
import CloseIcon from '@shared/icons/Close';
import AssetManagementBase from '@modules/Private/submodules/Assets/components/AssetManagement';
import { TOWER_FIELDS } from '@shared/constants/asset';

export interface AssetManagementProps {
  className?: string;
  open: boolean;
  manageMode: ManageMode;
  customerId: CustomerDTO['id'];
  formComponentProps: Partial<FormProps>;
}

@observer
class AssetManagement extends React.Component<AssetManagementProps> {
  private ordersStore = container.get<OrdersStore>(OrdersStore.diToken);

  private handleSubmit = (data: AssetDTO) => {
    this.ordersStore.setAsset({ id: data.id, type: data.type, name: data.name });
  }

  private shallNextLocationTerminateFormInstance = (currLocation: Location, nextLocation: Location) => {
    return currLocation.search != nextLocation.search;
  }

  render() {
    const { manageMode } = this.props;

    if (!manageMode) {
      return null;
    }

    const { open, formComponentProps, customerId } = this.props;
    const classes = withStyles.getClasses(this.props);

    return (
      <Dialog
        open={open}
        classes={{ paper: classes.root }}
      >
        <AssetManagementBase
          formComponentProps={{
            withCancelButtonOnCreate: true,
            closeComponent: <CloseIcon />,
            ignoringFieldsForConfirmation: [TOWER_FIELDS.customerId, TOWER_FIELDS.customerName],
            shallNextLocationTerminateFormInstance: this.shallNextLocationTerminateFormInstance,
            ...formComponentProps,
          }}
          onSubmit={this.handleSubmit}
          manageMode={manageMode}
          selectedCustomerId={customerId}
          classes={{
            formRoot: classes.formRoot,
          }}
        />
      </Dialog>
    );
  }
}

const AssetManagementStyled = withStyles(
  AssetManagement, 
  (theme, props) => ({
    "root": {
      width: 640,
      maxWidth: 'none',
      minHeight: 500,
      border: 'none',
    },
    "formRoot": {
      width: '100%',
      margin: 0,
    }
  })
);

export default AssetManagementStyled;